import { IMyOrderDetails } from "shared/Types/appTypes"
import { ApiResponse, ApiResponseTypes, ISuccessResponse } from "shared/Types/responseTypes"
import { get, getHeadersFromOptions, httpDelete, post } from "shared/Helpers/http"
import { CurrentEnvironment } from "shared/Modules/Environment/envTypes"
import { TransactionResponse } from "shared/Modules/Transaction/transactionTypes"
import { IMeetingServiceData } from "../../Types/MeetingPlanning/meetingServiceOrders"
import { objectToSearchString } from "../../Helpers/UrlHelper"
import { IMeetingServiceDetailResponse } from "../../Types/MeetingPlanning/meetingServiceOrderDetail"

export type OrderDetailsResponse = Readonly<{
    orders: IMyOrderDetails[]
}>

export type ForwardReceiptResponse = Readonly<{}>

export const getMeetingOrderDetails = (
    token: string,
    orderId: number,
    environment: CurrentEnvironment
): Promise<ApiResponse<OrderDetailsResponse>> => {
    // Call API
    return get(`/meetingService/orders/${orderId}`, {
        token,
        environment,
    })
}

export const getOrderDetails = (
    token: string,
    orderId: number,
    environment: CurrentEnvironment
): Promise<ApiResponse<OrderDetailsResponse>> => {
    // Call API
    return get(`/orders/${orderId}`, {
        token,
        environment,
    })
}

export const getOrderDetailsForMeetingPlanning = (
    token: string,
    orderId: number,
    environment: CurrentEnvironment
): Promise<ApiResponse<OrderDetailsResponse>> => {
    // Call API
    return get(`/meetingService/orders/${orderId}`, {
        token,
        environment,
    })
}

export const getOrderDetailsByUid = (
    token: string,
    orderUid: string,
    environment: CurrentEnvironment
): Promise<ApiResponse<OrderDetailsResponse>> => {
    return get(`/public/orders/${orderUid}`, {
        token,
        environment,
    })
}

export const getOrderDetailsIsomorphic = (
    token: string,
    orderId: number,
    orderUid: string,
    environment: CurrentEnvironment
) => {
    if (token) return getOrderDetails(token, orderId, environment)
    else return getOrderDetailsByUid(token, orderUid, environment)
}

export const forwardReceiptByEmail = (
    token: string,
    recipientEmail: string,
    orderUids: string[],
    environment: CurrentEnvironment
): Promise<ApiResponse<ForwardReceiptResponse>> => {
    return post("/public/receipts/sendByEmail", {
        body: {
            sendToEmail: recipientEmail,
            orders: orderUids.map((uid) => ({ uid })),
        },
        token,
        environment,
    })
}

export const deleteOrder = (
    orderId: number,
    token: string,
    environment: CurrentEnvironment
): Promise<ApiResponse<TransactionResponse>> => {
    return httpDelete(`/orders/${orderId}`, {
        token,
        environment,
    })
}

// TODO: This is temporary mock for get get Meting Services this will be replace with code below:

// export const getMetingServices = (token: string, environment: CurrentEnvironment, deliveredStartDate: string, deliveredEndDate: string): Promise<ApiResponse<IMyOrders>> => {
//     // Call API
//     const params = objectToSearchString({
//         startDate: deliveredStartDate,
//         endDate: deliveredEndDate
//     })
//     return http(new Request(ApiHelper.path(`/me/archive/meetingService?${params}`), {
//         method: 'GET',
//         headers: getHeadersFromOptions({ token, environment })
//     }));
// };

export const getMetingServices = async (
    token: string,
    environment: CurrentEnvironment,
    deliveredStartDate: string,
    deliveredEndDate: string
): Promise<ApiResponse<IMeetingServiceData>> => {
    const params = objectToSearchString({
        startDate: deliveredStartDate,
        endDate: deliveredEndDate,
    })
    const response = await fetch(
        `https://516f60fe-6c1a-4eca-8b8b-5ffbf30a2932.mock.pstmn.io/me/archive/meetingService?${params}`,
        {
            method: "GET",
            headers: getHeadersFromOptions({ token, environment }),
        }
    )

    const text = await response.text()

    try {
        const data = JSON.parse(text)

        return {
            type: ApiResponseTypes.SUCCESS,
            data,
            method: "GET",
            url: response.url,
            requestHeaders: [],
            responseCode: response.status,
            statusText: response.statusText,
            responseHeaders: [],
        } as ISuccessResponse<IMeetingServiceData>
    } catch {
        throw Error("Impossible to parse data")
    }
}

export const getMetingServiceDetails = async (
    token: string,
    environment: CurrentEnvironment,
    orderId: number
): Promise<ApiResponse<IMeetingServiceDetailResponse>> => {
    const response = await fetch(
        `https://516f60fe-6c1a-4eca-8b8b-5ffbf30a2932.mock.pstmn.io/meetingService/orders/${orderId}`,
        {
            method: "GET",
            headers: getHeadersFromOptions({ token, environment }),
        }
    )

    const text = await response.text()

    try {
        const data = JSON.parse(text)

        return {
            type: ApiResponseTypes.SUCCESS,
            data,
            method: "GET",
            url: response.url,
            requestHeaders: [],
            responseCode: response.status,
            statusText: response.statusText,
            responseHeaders: [],
        } as ISuccessResponse<IMeetingServiceDetailResponse>
    } catch {
        throw Error("Impossible to parse data")
    }
}

export const deleteMeetingServiceOrder = (
    orderId: number,
    token: string,
    environment: CurrentEnvironment
): Promise<ApiResponse<TransactionResponse>> => {
    return httpDelete(`/orders/${orderId}/meetingService`, {
        token,
        environment,
    })
}
